<template>
  <!--  -->
  <a-config-provider
    :locale="zhCN"
    :theme="{
      token: {
        colorPrimary: '#EA4325',
        borderRadius: 6
      }
    }"
  >
    <router-view />
  </a-config-provider>
</template>

<script setup>
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
dayjs.locale('zh-cn')
</script>

<style lang="scss"></style>
